/* istanbul ignore file */
import React from 'react';
import SkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/shared/SkillBasedQueueBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateSkillBasedQueueBreadcrumbs = () => {
  return (
    <SkillBasedQueueBreadcrumbs>
      <CreateBreadcrumbItem entity="SkillBasedQueue" />
    </SkillBasedQueueBreadcrumbs>
  );
};

export default CreateSkillBasedQueueBreadcrumbs;
